import styled from 'styled-components';
import Date from './component';

export default styled(Date)`
  color: var(--grey800);
  padding: 4px;
  background-color: var(--grey200);
  margin: 20px auto 28px auto;
  border-radius: 2px;
  font-weight: 500;
`;
